const showGenericLoader = () => {
  $('.generic-loader').removeClass('d-none');
};

const hideGenericLoader = () => {
  $('.generic-loader').addClass('d-none');
};

const navigatesAway = ($link) => {
  if ($link.attr('data-remote') === 'true' || $link.data('remote')) return false;
  if ($link.attr('data-toggle')) return false;
  if ($link.attr('target') === '_blank') return false;
  if ($link.attr('download')) return false;

  const href = $link.attr('href');
  if (!href || href === '#' || href.startsWith('#') || href.startsWith('javascript:')) return false;
  if (/^(tel|sms|mailto):/i.test(href)) return false;

  return true;
};

$(document).on('click', 'a[href]', function(event) {
  const $link = $(this);
  if (!navigatesAway($link)) return;
  if ($link.is('[aria-disabled="true"]')) return;

  showGenericLoader();
});

document.addEventListener('turbolinks:visit', showGenericLoader);
document.addEventListener('turbolinks:load', hideGenericLoader);
document.addEventListener('DOMContentLoaded', hideGenericLoader);
window.addEventListener('pageshow', hideGenericLoader);
